// Hook do usuwania załącznika ze zgłoszenia reklamacyjnego (Panel Klienta)

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

interface IRequest {
  id: number;
  attachmentId: number;
}

type IResponse = ICommandResponseSuccess;

const deleteReturnComplaintAttachment = ({ id, attachmentId }: IRequest): Promise<IResponse> =>
  axios.delete(`/return-complain/requests/${id}/attachments/${attachmentId}`);

export const useDeleteReturnComplaintAttachment = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => deleteReturnComplaintAttachment(data), options);
